import React, { useEffect, useState } from "react";
import { FaWhatsapp, FaEnvelope, FaMapMarkerAlt, FaMobileAlt } from 'react-icons/fa';
import { FiInstagram, FiFacebook, FiLinkedin, FiTwitter } from 'react-icons/fi';
import SummaryApi from '../common/index';
const ContactUs = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: '',
  });

  const [status, setStatus] = useState('');

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('Sending...');

    try {
      const response = await fetch(SummaryApi.createContact.url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        setStatus('✅ Message sent successfully!');
        setFormData({ name: '', email: '', phone: '', message: '' });
      } else {
        const errorData = await response.json();
        setStatus(`❌ Failed to send: ${errorData.message || 'Unknown error'}`);
      }
    } catch (error) {
      console.error(error);
      setStatus('❌ Failed to send message. Try again later.');
    }
  };

  return (
    <section
      className=" py-16 px-4 md:px-10 w-full flex flex-col items-center justify-center"
      aria-labelledby="Contact"
    >
      <div className="container mx-auto px-4">
        {/* Header */}
        <div className="section-header text-center mb-16">
          <h3 className="text-3xl font-bold mb-4 text-gray-800">Contact Us</h3>
          <p className="text-lg text-gray-600">
            Have questions or ready to start a project? Reach out to our team for personalized support.
          </p>
        </div>

        {/* Contact Info */}
        <div className="container mx-auto flex flex-col lg:flex-row justify-between px-4 mt-12">
          {/* Left Section */}
          <div className="lg:w-1/2 mb-8 lg:mb-0">
            <h2 className="text-2xl font-bold">Get in touch with our Expert Team</h2>
            <p className="mt-4 text-gray-700">
              Have something in mind? Need some advice?<br />
              We’d love to be a part of your digital journey.<br />
              Reach out to us on any platform below — we’re here to help!
            </p>

            {/* Social Media Icons */}
            <div className="flex space-x-4 mt-6 text-gray-700">
              <a href="https://wa.me/919309140606" target="_blank" rel="noopener noreferrer" className="hover:text-green-500">
                <FaWhatsapp size={22} />
              </a>
              <a href="https://www.instagram.com/shiksha_vistar?igsh=YWk1enFtbHplMXh1" target="_blank" rel="noopener noreferrer" className="hover:text-pink-500">
                <FiInstagram size={22} />
              </a>
              <a href="https://www.facebook.com/profile.php?id=61575247301098" target="_blank" rel="noopener noreferrer" className="hover:text-blue-600">
                <FiFacebook size={22} />
              </a>
              <a href="https://www.linkedin.com/company/shivaytech/?viewAsMember=true" target="_blank" rel="noopener noreferrer" className="hover:text-blue-700">
                <FiLinkedin size={22} />
              </a>
            </div>
          </div>

          {/* Right Section */}
          <div className="lg:w-1/2">
            <ul className="space-y-4 text-gray-800">
              <li className="flex items-center">
                <FaMapMarkerAlt className="mr-2 text-primary2" />
                <span>Beed, Maharashtra</span>
              </li>
              <li className="flex items-center">
                <FaEnvelope className="mr-2 text-primary2" />
                <span>shivaytech25@gmail.com</span>
              </li>
              <li className="flex items-center">
                <FaMobileAlt className="mr-2 text-primary2" />
                <span>+91 9309140606</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Google Map Section */}
        <div className="w-full mt-16">
          <h3 className="text-center text-2xl font-semibold mb-6 text-gray-800">Find Us on Map</h3>
          <div className="w-full h-[400px] rounded-2xl overflow-hidden shadow-lg border border-gray-200">
            <iframe
              title="Shivaytech Innovations"
              src="https://www.google.com/maps/embed?pb=!1m17!1m11!1m3!1d193.06611420877744!2d76.11351545075755!3d18.8127519741117!2m2!1f250.90281052262137!2f0!3m2!1i1024!2i768!4f35!3m3!1m2!1s0x3bc547341cb37897%3A0xe294773596a390e5!2sShiksha%20vistar!5e1!3m2!1sen!2sin!4v1762411983593!5m2!1sen!2sin"
              width="100%"
              height="100%"
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactUs;
